// extracted by mini-css-extract-plugin
export default {"recos":"_5-z","productCardOverride":"a6-z","rowHasBadge":"b6-z"};